import { createSlice } from '@reduxjs/toolkit';
import { ILeaveDetails } from '../interfaces';
import { getServerTime } from 'src/utils/DateHelper';

const initialState = {
  lastRefreshedTime: getServerTime()?.toString() || '',
  lastUpdatedAt: '',
  usersAvailability: [
    {
      userReferenceId: '',
      userName: '',
      leaveStatus: '',
      isActiveAllocation: false,
      leaves: [
        {
          from: '',
          to: '',
          type: ''
        }
      ]
    }
  ],
  summary: {
    BUFFER: 0,
    LONG_LEAVE_ACTIVE_ALLOCATION: 0,
    SHORT_LEAVE_ACTIVE_ALLOCATION: 0,
    NO_LEAVE_ACTIVE_ALLOCATION: 0,
    ON_LEAVE_INACTIVE_ALLOCATION: 0
  }
} as unknown as ILeaveDetails;

const leaveManagementSlice = createSlice({
  name: 'calendar',
  initialState,
  reducers: {
    setLeaveDetails: (state, action) => {
      const { usersAvailability, summary, lastUpdatedAt } = action.payload;
      state.usersAvailability = usersAvailability;
      state.summary = summary;
      state.lastUpdatedAt = lastUpdatedAt;
    },
    setLastRefreshedTime: (state, action) => {
      state.lastRefreshedTime = action.payload;
    }
  }
});

export const { setLeaveDetails, setLastRefreshedTime } = leaveManagementSlice.actions;

export default leaveManagementSlice.reducer;
